import Vue from 'vue';

import apiFactory from '@/api/default';
const API = apiFactory('gltf');

const state = {
  gltfSearchResults: [],
  currentGltf: null,
};

const getters = {
  gltfSearchResults: (state) => state.gltfSearchResults,
  currentGltf: (state) => state.currentGltf,
};

const mutations = {
  setGltfSearchResults: (state, gltfSearchResults) => {
    state.gltfSearchResults = gltfSearchResults;
  },
  updateGltfSearchResults: (state, task) => {
    const index = state.gltfSearchResults.findIndex((el)=>el._id === task._id);
    if (index >= 0) Vue.set(state.gltfSearchResults, index, task);
  },
  removeFromGltfSearchResults: (state, id)=>{
    state.gltfSearchResults.data = state.gltfSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.gltfSearchResults.total--;
  },
  setCurrentGltf: (state, currentGltf) => {
    state.currentGltf = currentGltf;
  },
};

const actions = {
  async searchGltf({commit}, name) {
    const response = await API.search(name);
    commit('setGltfSearchResults', response.data);
    return response.data;
  },
  async loadGltf({commit}, data) {
    const response = await API.load(data.id, data.query);
    commit('setCurrent', response.data);
    return response.data;
  },
  async createGltf({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async updateGltf({commit}, payload) {
    const response = await API.update(payload.id, payload.data);
    commit('updateGltfSearchResults', response.data);
    return response.data;
  },
  async deleteGltf({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromGltfSearchResults', id);
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
